import { render, staticRenderFns } from "./PageWrapper.vue?vue&type=template&id=0b0b31c7&scoped=true&"
import script from "./PageWrapper.vue?vue&type=script&lang=js&"
export * from "./PageWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PageWrapper.vue?vue&type=style&index=0&id=0b0b31c7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b31c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/django/wordbox-test.astroshock.ru/application/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0b0b31c7', component.options)
    } else {
      api.reload('0b0b31c7', component.options)
    }
    module.hot.accept("./PageWrapper.vue?vue&type=template&id=0b0b31c7&scoped=true&", function () {
      api.rerender('0b0b31c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/app/front/pages/PageWrapper.vue"
export default component.exports